module.exports = __webpack_public_path__ + "static/media/u8b_7.d27f93ee.mp3";